import script from "./uploadYsSfz.vue?vue&type=script&setup=true&lang=ts"
export * from "./uploadYsSfz.vue?vue&type=script&setup=true&lang=ts"

import "./uploadYsSfz.vue?vue&type=style&index=0&id=4714770e&lang=scss"
import "./uploadYsSfz.vue?vue&type=style&index=1&id=4714770e&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4714770e"]])

export default __exports__